import { useAppSelector } from '../app/store';
import { selectUser } from '../store/slices/userSlice';

export function useUser() {
    return useAppSelector(selectUser);
}
